import CategoryDashboard from './CategoryDashboard'

export default CategoryDashboard
